import { render, staticRenderFns } from "./EnergyConsumptionDataTable.vue?vue&type=template&id=ca739ab4&"
import script from "./EnergyConsumptionDataTable.vue?vue&type=script&lang=js&"
export * from "./EnergyConsumptionDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports